import { useMemo, useState } from "react";

import AddIcon from "@mui/icons-material/Add";

import { Box } from "@mui/material";
import { Button, Layout, Paper } from "$components";

import useJStyles from "$hooks/useJStyles";
import { getCoordinators } from "$services/Coordinators.service";

import {
  DataTableWithContext,
  EnumDataRowType,
  EnumFilterTypes,
} from "$components/DataTable";
import { usePopin } from "$components/Popin/usePopin";
import { useQueryParameters } from "$hooks/useQueryParameters";
import clientFormData from "./clientForm.content";
import formsData from "./forms.content";
import { CoordinatorPopin } from "./CoordinatorsPopin";
import { CacheInvalidationAction } from "$utils/cache";

export { clientFormData as ClientFormData, formsData as UserFormData };

export interface ICoordinatorsProps {
  className?: string;
}

function Coordinators({ className }: ICoordinatorsProps) {
  const { jclasses } = useJStyles();
  const [user, setUser] = useState();
  const { Popin, PopinProps, togglePopin } = usePopin();

  const params = useQueryParameters();

  const useMakeCell = (value) => {
    return {
      type: EnumDataRowType.EmptyLink,
      value,
      onClick: async (row) => {
        setUser(row);
        togglePopin();
      },
    };
  };

  const externalState = useMemo(() => {
    const returnState = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of params.entries()) {
      returnState[key] = value;
    }
    const { page, rowsPerPage, ...filters } = returnState as any;

    return {
      filters: { ...filters },
      pagination: { page, rowsPerPage },
    };
  }, [params]);

  const headerData = [
    {
      id: "name",
      filter: {
        type: EnumFilterTypes.INPUT,
        label: "Coordinateur",
        placeholder: "Par nom",
        value: params.get("name"),
      },
      minWidth: 170,
      cell: {
        ...useMakeCell(({ firstname, lastname }) => `${firstname} ${lastname}`),
      },
    },
    {
      id: "email",
      filter: {
        type: EnumFilterTypes.INPUT,
        value: params.get("email"),
        label: "Email",
        placeholder: "Par email",
      },
      minWidth: 170,
      cell: {
        ...useMakeCell(({ email }) => email),
      },
    },
  ];

  return (
    <Box className={jclasses.jWrapper}>
      <Layout
        title="Liste des coordinateurs logistiques"
        contentClassName={jclasses.jLayoutCustom}
      >
        <Paper className={`${jclasses.jPaper} ${className || ""}`}>
          <DataTableWithContext
            externalState={externalState}
            buttonList={[
              <Button
                variant="outlined"
                onClick={() => {
                  setUser(null);
                  togglePopin();
                }}
                startIcon={<AddIcon />}
              >
                Ajouter un coordinateur
              </Button>,
            ]}
            rowsPerPage={50}
            thead={headerData}
            queryFunction={getCoordinators}
            queryFunctionName={CacheInvalidationAction.GET_COORDINATORS}
            data-testid="coordinatorList"
          />
        </Paper>
        <Popin {...PopinProps}>
          <CoordinatorPopin
            togglePopin={togglePopin}
            user={user}
            setUser={setUser}
          />
        </Popin>
      </Layout>
    </Box>
  );
}

export default Coordinators;
